export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/bundle.92265732fb42b3694728.worker.js");
}
